export default __webpack_public_path__ + "static/media/dot-net.ab2b205a.svg";